import api from '@/services/Api';

export default {
  getList(companyId) {
    return api().get('/company/' + companyId + '/in-app-notifications')
      .then(resp => resp.map(item => ({
        ...item,
        created_at: item.created_at ? new Date(item.created_at) : null,
      })));
  },

  dismiss(companyId, notificationId) {
    return api().put('/company/' + companyId + '/in-app-notification/' + notificationId + '/dismiss');
  },
};
